import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { PATHS } from "util/appConstants";
import Navbar from "components/Navbar";
import LightLayout from "components/Shared/LightLayout";
import PermissionForm from "components/Permissions/form";
import { addPermission, getAllModules, selectModules, selectPermissionsStatus, getAllPermissions, selectPermissions } from "redux/slices/permissionsSlice";
import { selectUser } from "redux/slices/userSlice";

const currentAction = "ADD";
const AddPermission = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const modules = useSelector(selectModules);
  const permissions = useSelector(selectPermissions);
  const user = useSelector(selectUser);
  const loading = useSelector(selectPermissionsStatus);

  const canEditPermissions =
    user?.isSuperAdmin ||
    Boolean(user?.admin && import.meta.env.VITE_PERMISSION_EDITABLE_BY_ADMIN === "true");

  useEffect(() => {
    if (user && !canEditPermissions) {
      history.push(PATHS.admin.permissions);
      return;
    }
    if (!loading) {
      dispatch(getAllModules());
      dispatch(getAllPermissions());
    }
  }, [dispatch]);

  const onSubmit = async (payload) => {
    await dispatch(addPermission(payload)).then((res) =>
      res !== undefined ? history.push(PATHS.admin.permissions) : ""
    );
  };

  return (
    <>
      <Navbar />
      <LightLayout doublebar>
        <PermissionForm action={currentAction} onSubmit={onSubmit} modules={modules} permissions={permissions} />
      </LightLayout>
    </>
  );
};

export default AddPermission;
